import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

const getConnectImageForMake = (make: string) => {
  if (make.includes('alfa romeo')) return 'alfa'
  if (make.includes('audi')) return 'audi'
  if (make.includes('bmw')) return 'bmw'
  if (make.includes('citroen')) return 'citroen'
  if (make.includes('ds')) return 'ds'
  if (make.includes('fiat')) return 'fiat'
  if (make.includes('ford')) return 'ford'
  if (make.includes('jeep')) return 'jeep'
  if (make.includes('mercedes')) return 'mercedes'
  if (make.includes('mini')) return 'mini'
  if (make.includes('peugeot')) return 'peugeot'
  if (make.includes('porsche')) return 'porsche'
  if (make.includes('tesla')) return 'tesla'
  if (make.includes('vauxhall')) return 'vauxhall'
  if (make.includes('volvo')) return 'volvo'
}

const getImage = (resolution: 'desktop' | 'tablet' | 'mobile', hasByMilesTracker: boolean, make: string) => {
  if (hasByMilesTracker) {
    return `miles-tracker-only/miles-tracker-${resolution}.png`
  }

  // When not using a by miles tracker show an image of by miles app connecting with the specific make.
  return `connect-images/${getConnectImageForMake(make)}-${resolution}.jpg`
}

interface MilesTrackerStyleProps {
  hasByMilesTracker: boolean
  make: string
}

export const MilesTrackerStyle = styled.div<MilesTrackerStyleProps>`
  border-radius: 8px;
  background: white;
  overflow-x: hidden;

  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: ${theme.grid.resolution.tablet.container}px;
    margin: 0 auto;
  }

  @media (min-width: ${theme.grid.resolution.desktop.width}px) {
    width: ${theme.grid.resolution.desktop.container}px;
  }
  .image-container {
    background: ${props =>
      `url(../v2/assets/miles-tracker/${getImage('mobile', props.hasByMilesTracker, props.make)})`};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: ${props => (props.hasByMilesTracker ? 'initial' : 'center')};
    width: 100%;
    height: 150px;
    border-radius: 8px 8px 0 0;

    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      background: ${props =>
        `url(../v2/assets/miles-tracker/${getImage('tablet', props.hasByMilesTracker, props.make)})`};
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 8px 0 0 8px;
      height: auto;
      min-height: 600px;
    }

    @media (min-width: ${theme.grid.resolution.desktop.width}px) {
      background: ${props =>
        `url(../v2/assets/miles-tracker/${getImage('desktop', props.hasByMilesTracker, props.make)})`};
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .copy-container {
    padding: 32px 24px;

    .heading-icon-wrapper {
      display: flex;
      max-width: 280px;

      @media (min-width: ${theme.grid.resolution.desktop.width}px) {
        max-width: none;
      }

      .icon__close {
        margin: 0 8px 0 0;
        svg {
          position: initial;
          width: 20px;
        }
      }
    }

    .connect-header {
      margin-top: ${theme.grid.spacing.md}px;
    }

    .icon__info {
      cursor: pointer;
    }

    .miles-tracker-info {
      margin: 16px 0 18px 30px;
      padding: 16px 22px 24px 22px;
      width: auto;
    }

    .helper-container {
      display: flex;
      align-items: center;
      margin-top: 8px;
      grid-gap: 12px;
    }
  }

  .connect-toggle-wrapper {
    position: relative;
    padding-bottom: ${theme.grid.spacing.base}px;
    margin-bottom: ${theme.grid.spacing.md}px;
    .title {
      margin-bottom: ${theme.grid.spacing.xs}px;
    }
    .connect-p {
      position: relative;
      margin-bottom: ${theme.grid.spacing.s}px;
    }
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      background: ${theme.tints.aubergine};
      bottom: 0;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .connect-high-mobility {
    color: ${theme.primaryColours.cyan.superDarkCyan};
    cursor: pointer;

    &:hover {
      color: ${theme.primaryColours.cyan.darkCyan};
    }

    .connect-high-mobility-tooltip {
      max-width: 100%;
      z-index: 10;
    }
  }
`
